"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconHomeOfficeFilled = function IconHomeOfficeFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.36 17.36L38.36 14.72V8.24001C38.36 7.94296 38.242 7.65809 38.0319 7.44805C37.8219 7.23801 37.537 7.12001 37.24 7.12001H31.67C31.3729 7.12001 31.0881 7.23801 30.878 7.44805C30.668 7.65809 30.55 7.94296 30.55 8.24001V9.49001L25.6 6.20001C25.405 6.06846 25.1752 5.99817 24.94 5.99817C24.7048 5.99817 24.4749 6.06846 24.28 6.20001L7.52998 17.36C7.36556 17.4696 7.23102 17.6184 7.13849 17.793C7.04596 17.9676 6.99836 18.1624 6.99998 18.36V42.8C6.99998 42.9576 7.03102 43.1136 7.09132 43.2592C7.15163 43.4048 7.24002 43.5371 7.35145 43.6485C7.46288 43.76 7.59517 43.8484 7.74076 43.9087C7.88635 43.969 8.04239 44 8.19998 44H41.68C41.8376 44 41.9936 43.969 42.1392 43.9087C42.2848 43.8484 42.4171 43.76 42.5285 43.6485C42.6399 43.5371 42.7283 43.4048 42.7886 43.2592C42.8489 43.1136 42.88 42.9576 42.88 42.8V18.35C42.8802 18.1552 42.8329 17.9632 42.7423 17.7907C42.6517 17.6182 42.5205 17.4704 42.36 17.36ZM32.47 13.28C32.397 13.3229 32.3145 13.3469 32.23 13.35C32.3143 13.3454 32.3964 13.3215 32.47 13.28ZM39.64 40.76H10.24V19.52L24.94 9.83001L29 12.56L31.33 14.09C31.5657 14.2458 31.8393 14.3346 32.1216 14.347C32.4038 14.3594 32.6842 14.2949 32.9326 14.1604C33.1811 14.0259 33.3884 13.8264 33.5323 13.5833C33.6763 13.3402 33.7515 13.0625 33.75 12.78V10.35H35.11V15.79C35.1078 16.0506 35.1718 16.3075 35.296 16.5366C35.4202 16.7657 35.6005 16.9596 35.82 17.1L39.6 19.53L39.64 40.76Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 33V38.5C37 38.6326 36.9473 38.7598 36.8536 38.8536C36.7598 38.9473 36.6326 39 36.5 39H13.5C13.3674 39 13.2402 38.9473 13.1464 38.8536C13.0527 38.7598 13 38.6326 13 38.5V33H22C22 33.5304 22.2107 34.0391 22.5858 34.4142C22.9609 34.7893 23.4696 35 24 35H26C26.5304 35 27.0391 34.7893 27.4142 34.4142C27.7893 34.0391 28 33.5304 28 33H37Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29 23V19.5C29 19.3674 28.9473 19.2402 28.8536 19.1464C28.7598 19.0527 28.6326 19 28.5 19H21.5C21.3674 19 21.2402 19.0527 21.1464 19.1464C21.0527 19.2402 21 19.3674 21 19.5V23H13.5C13.3674 23 13.2402 23.0527 13.1464 23.1464C13.0527 23.2402 13 23.3674 13 23.5V31H22V28H28V31H37V23.5C37 23.3674 36.9473 23.2402 36.8536 23.1464C36.7598 23.0527 36.6326 23 36.5 23H29ZM23 21H27V23H23V21Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 30H26V32.5C26 32.6326 25.9473 32.7598 25.8536 32.8536C25.7598 32.9473 25.6326 33 25.5 33H24.5C24.3674 33 24.2402 32.9473 24.1464 32.8536C24.0527 32.7598 24 32.6326 24 32.5V30Z",
    fill: color
  }));
};

IconHomeOfficeFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconHomeOfficeFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconHomeOfficeFilled;
exports.default = _default;